/*
 * CatalogEditConstants
 */

export const SET_LOADING = 'ideal/CatalogEdit/SET_LOADING';
export const GET_OFFER = 'ideal/CatalogEdit/GET_OFFER';
export const DELETE_OFFER = 'ideal/CatalogEdit/DELETE_OFFER';
export const OFFER_RECEIVED = 'ideal/CatalogEdit/OFFER_RECEIVED';
export const EDIT_OFFER = 'ideal/CatalogEdit/EDIT_OFFER';
export const STORE_CHILD_OFFERS = 'ideal/CatalogEdit/STORE_CHILD_OFFERS';
export const REQUEST_SUCCESS_RESPONSE = 'ideal/CatalogEdit/REQUEST_SUCCESS_RESPONSE';
export const REQUEST_ERROR_RESPONSE = 'ideal/CatalogEdit/REQUEST_ERROR_RESPONSE';
export const REDIRECT_TO_PAGE = 'ideal/CatalogEdit/REDIRECT_TO_PAGE';
export const RESET = 'ideal/CatalogEdit/RESET';
